<script lang="ts">
  import { onMount } from 'svelte'
  import { api, type AuditEntry } from '../lib/api'
  import { fmtDate, fmtRelative } from '../lib/utils'
  import { formatEntity, formatAction, formatPayload } from '../lib/audit'

  let entries = $state<AuditEntry[]>([])
  let search = $state('')
  let filterAction = $state('')
  let filterEntity = $state('')

  onMount(async () => { entries = await api.listAudit(200) })

  let visible = $derived(entries.filter(e => {
    if (filterAction && e.action !== filterAction) return false
    if (filterEntity && e.entityType !== filterEntity) return false
    if (search) {
      const hay = [e.username, e.action, e.entityType, e.payload].filter(Boolean).join(' ').toLowerCase()
      if (!hay.includes(search.toLowerCase())) return false
    }
    return true
  }))

  let actions = $derived([...new Set(entries.map(e => e.action))].sort())
  let entityTypes = $derived([...new Set(entries.map(e => e.entityType))].sort())
</script>

<div class="card mb-4">
  <div class="flex flex-wrap gap-2 items-center">
    <input class="input flex-1 min-w-[200px]" placeholder="Поиск по журналу..." bind:value={search}>
    <select class="input w-auto" bind:value={filterAction}>
      <option value="">Все действия</option>
      {#each actions as a}<option value={a}>{formatAction(a)}</option>{/each}
    </select>
    <select class="input w-auto" bind:value={filterEntity}>
      <option value="">Все объекты</option>
      {#each entityTypes as t}<option value={t}>{formatEntity(t, null)}</option>{/each}
    </select>
    <span class="text-xs text-muted ml-auto">{visible.length} из {entries.length}</span>
  </div>
</div>

<!-- Desktop: table -->
<div class="card overflow-hidden p-0 hidden sm:block">
  <table class="tbl">
    <thead>
      <tr>
        <th>Время</th>
        <th>Пользователь</th>
        <th>Действие</th>
        <th>Объект</th>
        <th>Детали</th>
      </tr>
    </thead>
    <tbody>
      {#each visible as e (e.id)}
        <tr>
          <td class="text-xs text-muted whitespace-nowrap" title={fmtDate(e.createdAt)}>{fmtRelative(e.createdAt)}</td>
          <td class="text-xs font-medium">{e.username || '—'}</td>
          <td>
            <span class="badge badge-{e.action==='delete'?'red':e.action==='create'?'green':e.action==='update'?'blue':'neutral'}">
              {formatAction(e.action)}
            </span>
          </td>
          <td class="text-xs">{formatEntity(e.entityType, e.entityId)}</td>
          <td class="text-xs text-muted max-w-[400px] truncate" title={formatPayload(e.payload)}>
            {formatPayload(e.payload) || ''}
          </td>
        </tr>
      {/each}
      {#if visible.length === 0}
        <tr><td colspan="5" class="text-center text-muted py-8">Ничего не найдено</td></tr>
      {/if}
    </tbody>
  </table>
</div>

<!-- Mobile: cards -->
<div class="sm:hidden space-y-2">
  {#each visible as e (e.id)}
    <div class="card p-3">
      <div class="flex items-center gap-2 flex-wrap mb-1">
        <span class="font-medium text-sm">{e.username || '—'}</span>
        <span class="badge badge-{e.action==='delete'?'red':e.action==='create'?'green':e.action==='update'?'blue':'neutral'}">
          {formatAction(e.action)}
        </span>
        <span class="text-sm">{formatEntity(e.entityType, e.entityId)}</span>
        <span class="text-xs text-muted ml-auto">{fmtRelative(e.createdAt)}</span>
      </div>
      {#if formatPayload(e.payload)}
        <div class="text-xs text-muted mt-1">{formatPayload(e.payload)}</div>
      {/if}
    </div>
  {/each}
  {#if visible.length === 0}
    <div class="text-center text-muted py-8 card">Ничего не найдено</div>
  {/if}
</div>
